module.exports = __webpack_public_path__ + "static/media/why-img.e8bc57ef.png";